/**
 * Product Catalog UI types — backend SKU rows are mapped here by the page.
 * Tier prices are placeholder columns until the pricing-tier UI is wired
 * (currently the same list_price is shown in all four tier columns).
 */

export interface ProductItem {
  sku: string;
  barcode?: string | null;
  name: string;
  ageRestriction?: '21+' | '18+';
  category: string;
  cost: number;
  tierA: number;
  tierB: number;
  tierC: number;
  tierD: number;
  stock: number;
  margin: number;
  // Backend id preserved for row-level actions
  id: number;
  imageUrl?: string | null;
}

export const categoryColors: Record<string, string> = {
  Cigarettes: '#3B82F6',
  Vapes: '#8B5CF6',
  Energy: '#F59E0B',
  Cigars: '#6366F1',
  Wraps: '#10B981',
  Accessories: '#6B7280',
  Snacks: '#EF4444',
  Beverages: '#0EA5E9',
};

export const statusOptions = ['Active', 'Inactive', 'Discontinued'];

export const ITEMS_PER_PAGE = 50;
